var Request = require('./helper/request');
var Storage = require('./helper/storage');

function Authentication(app){
  var self = this;
  self.passwordSendUri = "/iam/user/password_send";
  self.loginUri = "/iam/user/passphrase";
  self.passphraseList = "/iam/user/:user_id/passphrase";
  self.tokenUri = "/iam/access/token";
  self.logoutUri = "/iam/user/passphrase/invalidation";
  self.request = new Request(app);
  self.storage = new Storage();
}

Authentication.prototype.passwordSend = function(phone_number){
  var self = this;
  return self.request.post(self.passwordSendUri, {
    password_send: {
      phone_number: phone_number
    }
  });
}

Authentication.prototype.login = function(phone_number, password){
  var self = this;
  return self.request.post(self.loginUri, {
    credentials: {
      phone_number: phone_number,
      password: password
    }
  }).then(function(e){
    var response = self.request.successHandler(e);
    var passphrase = response.data.passphrase;
    self.storage.store.setItem('passphrase', passphrase.passphrase);
    self.storage.store.setItem('passphrase_id', passphrase.id);
    return e;
  });
}

Authentication.prototype.token = function(passphrase){
  var self = this;
  return self.request.post(self.tokenUri, {
    passphrase_submission: {
      passphrase: passphrase
    }
  }).then(function(e){
    var response = self.request.successHandler(e);
    var token = response.data.token.jwt;
    self.storage.store.setItem('token', token);
    return e;
  });
}

Authentication.prototype.logout = function(data){
  var self = this;
  var passphraseId = self.storage.store.getItem('passphrase_id');
  return self.request.post(self.logoutUri, {
    passphrase_invalidation: {
      target_passphrase_id: parseInt(passphraseId)
    }
  }).then(function(e){
    self.storage.store.removeItem('passphrase_id');
    self.storage.store.removeItem('token');
    self.storage.store.removeItem('passphrase');
    return e;
  });
}

Authentication.prototype.passphraseInvalidation = function(passphrase_id){
  var self = this;
  var passphraseId = passphrase_id;
  return self.request.post(self.logoutUri, {
    passphrase_invalidation: {
      target_passphrase_id: parseInt(passphraseId)
    }
  }).then(function(e){
    return e;
  });
}

Authentication.prototype.sessionList = function(userId){
  var self = this;
  var uri = self.passphraseList.replace(":user_id", userId);
  return self.request.get(uri);
}

module.exports = Authentication;
